/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { PauseMonitorMutationResponse, PauseMonitorPathParams, PauseMonitor401, PauseMonitor404 } from '../types/PauseMonitor.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getPauseMonitorUrl(id: PauseMonitorPathParams['id']) {
  const res = { method: 'POST', url: `/v1/monitors/${id}/pause` as const };
  return res;
}

/**
 * @summary Pause a monitor
 * {@link /v1/monitors/:id/pause}
 */
export async function pauseMonitor(id: PauseMonitorPathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<PauseMonitorMutationResponse, ResponseErrorConfig<PauseMonitor401 | PauseMonitor404>, unknown>({
    method: 'POST',
    url: getPauseMonitorUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
